import type { Column } from '@tanstack/react-table';
import { getSelectedLanguage } from '@frontend/translate';
import { DebouncedInput } from './DebouncedInput';

type ColumnTextInputFilterProps<T> = {
    column: Column<T, unknown>;
    sortedUniqueValues: [string, number][];
};

export function ColumnTextInputFilter<T>({ column, sortedUniqueValues }: Readonly<ColumnTextInputFilterProps<T>>) {
    const translate = getSelectedLanguage();
    const columnFilterValue = column.getFilterValue();

    return (
        <>
            <datalist id={`${column.id}list`}>
                {sortedUniqueValues.map(([key]) => (
                    <option
                        key={key}
                        value={key}
                    />
                ))}
            </datalist>
            <DebouncedInput
                list={`${column.id}list`}
                onChange={(value) => column.setFilterValue(value)}
                placeholder={`${translate.common.searchForSingular} ${column.columnDef.header}`}
                type="text"
                value={columnFilterValue as string}
            />
        </>
    );
}
